import React from 'react';
import { useDrag } from 'react-dnd';

const FirstNameCard = () => {
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'first-name', linkId: 'FIRST_NAME' },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  })

  return <div
    ref={drag}
    style={{
      cursor: 'move',
      opacity: isDragging ? 0.1 : 1
    }}
    className="card mb-2">
    <div className="card-body p-2">
      <h6 className="card-title m-0">First Name</h6>
    </div>
  </div>
}

export default FirstNameCard;